export const debounce = (callbackFunc, delay = 200) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      callbackFunc(...args)
    }, delay)
  }
}
